import { gql } from '@apollo/client';

export const LIMIT = 20;
export const SKIP = 0;

const TEST_SESSION_FIELDS = gql`
  fragment TestSessionFields on TestSession {
    id
    tester {
      id
      user {
        id
        profile {
          id
          firstName
        }
      }
    }
  }
`;

export const TAG_ANALYTICS = gql`
  query TagAnalytics(
    $companyId: ID!,
    $projectIds: [ID!],
    $tagIds: [ID!],
    $selectedTag: [ID!],
    $createdAtStart: ISO8601DateTime,
    $createdAtEnd: ISO8601DateTime,
    $limit: Int,
    $offset: Int
  ) {
      tagAnalytics(
        companyId: $companyId,
        projectIds: $projectIds,
        tagIds: $tagIds,
        createdAtStart: $createdAtStart,
        createdAtEnd: $createdAtEnd,
      ) {
          id
          totalPeriod
          tag {
            id
            tagType
            name
            tagGroup {
              id
              color
            }
          }
      }
      tagHighlights(
        companyId: $companyId,
        projectIds: $projectIds,
        tagIds: $selectedTag,
        createdAtStart: $createdAtStart,
        createdAtEnd: $createdAtEnd,
        limit: $limit,
        offset: $offset
      ) {
          id
          createdAt
          charStart
          charEnd
          entityType
          tag {
            id
            name
            tagType
            tagGroup {
              id
              color
            }
          }
          project {
            id
            name
          }
          createdBy {
            id
            profile {
              id
              firstName
              lastName
            }
          }
          entity {
            ... on TestSessionAnswer {
              id
              videoUrl
              videoStartTime
              transcriptText
              transcript {
                results {
                  alternatives {
                    confidence
                    transcript
                  }
                }
              }
              testSession {
                ...TestSessionFields
              }
            }
            ... on TestSessionNote {
              id
              videoUrl
              note
              noteType
              testSession {
                ...TestSessionFields
              }
            }
            ... on TestSessionSpeaker {
              id
              text
              videoStartTime
              testSession {
                ...TestSessionFields
              }
            }
          }
      }
  }
  ${TEST_SESSION_FIELDS}
`;
